import React from "react";
import { Star } from "lucide-react";
import { REVIEWS } from "@/data/reviews";

function Stars({ n }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`h-4 w-4 ${i <= n ? "fill-[#00E676] text-[#00E676]" : "text-zinc-300"}`} />
      ))}
    </div>
  );
}

export default function Reviews() {
  const avg = (REVIEWS.reduce((a, r) => a + r.rating, 0) / REVIEWS.length).toFixed(1);
  return (
    <section className="container-x py-20" data-testid="reviews-section">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">What Drivers Say</p>
          <h2 className="mt-2 font-heading text-3xl font-bold tracking-tight sm:text-4xl">
            Trusted by Manchester PHV Drivers
          </h2>
        </div>
        <div className="flex items-center gap-3">
          <Stars n={Math.round(avg)} />
          <span className="font-heading text-2xl font-black">{avg}</span>
          <span className="text-sm text-zinc-500">from {REVIEWS.length} driver reviews</span>
        </div>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <figure key={i} className="flex flex-col border border-border bg-white p-6" data-testid={`review-${i}`}>
            <Stars n={r.rating} />
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-zinc-700">“{r.text}”</blockquote>
            <figcaption className="mt-5 border-t border-border pt-4">
              <span className="font-heading font-bold text-ink">{r.name}</span>
              <span className="ml-2 text-sm text-zinc-500">{r.location}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
